import React from 'react';

import { FormattedMessage } from 'react-intl-next';

import { Box, Stack } from '@atlaskit/primitives';
import ProgressBar from '@atlaskit/progress-bar';

import { useMatch } from 'src/router/hooks';

import { PR_PATH } from '../constants';
import { useNumFilesReviewed } from '../reviewed-files/reviewed-files-provider';

import messages from './reviewed-files-progress-bar.i18n';
import * as styles from './styles';

type ProgressBarProps = {
  numTotalFiles: number;
  tabIndex?: number;
  hideProgressBar?: boolean;
};

export const ReviewedFilesProgressBar = ({
  numTotalFiles,
  tabIndex = 0,
  hideProgressBar = false,
}: ProgressBarProps): JSX.Element | null => {
  const numFilesViewed = useNumFilesReviewed();

  const { path } = useMatch();
  const isPrPage = path === PR_PATH;

  if (numTotalFiles === 0) {
    return null;
  }

  const title = (
    <FormattedMessage
      {...messages.progressBarTitle}
      values={{
        fileCount: (
          <b>
            <FormattedMessage
              {...messages.progressBarFileCount}
              values={{ numFilesViewed, numTotalFiles }}
            />
          </b>
        ),
      }}
    />
  );

  return (
    <>
      {isPrPage ? (
        <Stack>
          <Box>{title}</Box>
          {!hideProgressBar && (
            <Box tabIndex={tabIndex}>
              <ProgressBar value={numFilesViewed / numTotalFiles} />
            </Box>
          )}
        </Stack>
      ) : (
        <styles.ReviewedProgressBar>
          {title}
          <ProgressBar value={numFilesViewed / numTotalFiles} />
        </styles.ReviewedProgressBar>
      )}
    </>
  );
};
